export default __webpack_public_path__ + "svg/why/excellence.svg?e258dfe8";